import Bugsnag, { NotifiableError } from '@bugsnag/js'
import axios, { AxiosError } from 'axios'
import { TrackingPayloadMBS, TrackingPayloadRanch } from './constants'

Bugsnag.start({
    apiKey: process.env.BUGSNAG_API_KEY!,
    releaseStage: process.env.NODE_ENV,
})

export const tracking = async (trackingData: TrackingPayloadMBS | TrackingPayloadRanch) => {
    const response = await axios.post(process.env.TRACKING_API!, trackingData).catch((error: AxiosError) => {
        errorLogger(error)
        return error
    })

    return response.status === 200
}

export const errorLogger = (error: NotifiableError) => {
    Bugsnag.notify(error)
}

export const getLocale = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const userLang = (queryParameters.has('lang') && queryParameters.get('lang')) || navigator.language
    return userLang
}

export const translatePage = (texts: Record<string, string>) => {
    const elements = document.querySelectorAll<HTMLElement>('[data-lang-tag]')

    for (const element of elements) {
        const langTagName = element.dataset.langTag!
        if (texts[langTagName]) {
            element.innerHTML = texts[langTagName]
        }

        if (langTagName === '@year') {
            element.textContent = new Date().getFullYear().toString()
        }
    }
}

export const addNewFormEntry = (name: string, value: string, formElement: HTMLFormElement) => {
    const input = document.createElement('input') as HTMLInputElement
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', name)
    input.setAttribute('value', value)
    formElement.append(input)
}

export const preloadLink = (href: string) => {
    const element = document.createElement('link')
    element.href = href
    document.head.append(element)
}
